import { ServerUrls } from '../../app/ServerUrls';
import { Location } from '../../common/react/Location';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { CreateSiteAction } from '../services/CreateSiteAction';

export interface IAddSiteScope extends ng.IScope {
  createSite: () => void;
}

export class AddSiteCtrl {

  public static $inject = [
    '$scope',
    'BrowserTitleService',
    'CreateSiteAction'
  ];

  constructor(
    scope: IAddSiteScope,
    BrowserTitleService: BrowserTitleService,
    createSiteAction: CreateSiteAction
  ) {
    BrowserTitleService.setTitleWithPlace({translatablePlaceName: 'serverSettings_addSite'});
    scope.createSite = () => createSiteAction.execute(scope)
      .then(() => {
        Location.instance.setUrl(ServerUrls.getInstance().sitesUrl());
      });
  }
}
